<template>
    <div class="background">
        <div class="inputForm">
            <van-row>
                <van-col span="12">
                    <a href="https://u.jd.com/rt19PO">
                        <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxzGqLV.jpg" width="90%"/>
                    </a>
                </van-col>
                <van-col span="12">
                    <a href="https://u.jd.com/t0OuTL">
                        <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxzGpRD.jpg" width="90%"/>
                    </a>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="12">
                    <a href="https://u.jd.com/nai961">
                        <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxzGoQt.jpg" width="90%"/>
                    </a>
                </van-col>
                <van-col span="12">
                    <a href="https://u.jd.com/FkwikT">
                        <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxzGnYs.jpg" width="90%"/>
                    </a>
                </van-col>
            </van-row>

            <van-row v-if="jobInfo" style="margin: 1rem 0;">
                <van-col span="12">
                    <van-button type="danger" size="large" :url="jobInfo.linkAtrr1" style="width:90%;">
                        <div style="font-size: 1.6rem;">
                            领6元金贴
                        </div>
                    </van-button>
                </van-col>
                <van-col span="12">
                    <van-button type="danger" size="large" :url="jobInfo.jobLink" style="width:90%;">
                        <div style="font-size: 1.6rem;">
                            拿40元红包
                        </div>
                    </van-button>
                </van-col>
            </van-row>

            <div style="font-size: 1rem; margin-top: 1rem;">
                温馨提示<br/>
                白条新用户享受特价<br/>
                非白条新用户无法享受此优惠
            </div>

            <div v-if="jobInfo" style="margin-top: 1rem; text-align:center;">
                <van-row>
                    <van-col span="12">
                        <van-button plain hairline type="danger" size="small"
                                    url="https://www9.53kf.com/m.php?kf_sign=jk4NjMTU5MU0MzExNzc5NTk0NDkxMDEyNzIyMjQyODA%253D&arg=10224280&style=1&cid=72224280">
                            联系客服
                        </van-button>
                    </van-col>
                    <van-col span="12">
                        <van-button plain hairline type="danger" size="small" @click="dialogVisible=true">
                            分享海报
                        </van-button>
                    </van-col>
                </van-row>
            </div>
        </div>

        <van-dialog v-model="dialogVisible" confirm-button-text="长按图片保存至本地" close-on-click-overlay>
            <img :src="shareImgSrc" width="100%"/>
            <vue-canvas-poster :widthPixels="640" :painting="painting" @success="success" @fail="fail">
            </vue-canvas-poster>
        </van-dialog>
    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import constantAPI from '@/api/constant';
    import wxShare from '@/utils/wxShareService';
    import pvuvAPI from '@/api/pvuv';
    import {VueCanvasPoster} from 'vue-canvas-poster';

    export default {
        components: {
            VueCanvasPoster,
        },
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                },
                jobInfo: null,
                dialogVisible: false,
                shareImgSrc: '',
                painting: {
                    width: '640px',
                    height: '1008px',
                    background: '#f4f5f7',
                    views: [
                        {
                            type: 'image',
                            url: require('../../../assets/posters/baitiao_shopping.png'),
                            css: {
                                // top: '20px',
                                // left: '36px',
                                // width: '80px',
                                // height: '80px'
                            }
                        },
                        {
                            type: 'rect',
                            css: {
                                top: '630px',
                                left: '430px',
                                color: '#fff',
                                width: '166px',
                                height: '166px'
                            }
                        },
                        {
                            type: 'qrcode',
                            content: window.location.href,
                            css: {
                                top: '633px',
                                left: '433px',
                                color: '#000',
                                width: '160px',
                                height: '160px'
                            }
                        }
                    ]
                }
            }
        },
        methods: {
            success(src) {
                this.shareImgSrc = src;
            },
            fail(err) {
                console.log('fail', err)
            },
        },
        created() {
            document.title = "京东白条购物";
            if (!this.query.traderId) {
                return;
            }

            mainAPI.getInfoByTraderId(52, this.query.traderId).then((result) => {
                this.jobInfo = result.data;
            }).catch(() => {
            })
        },
        mounted() {
            let shareInfo = {
                "imgUrl": "http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O05KE2O.png",
                "title": "京东白条购物",
                "desc": "6元金贴 + 40元现金红包",
                "link": window.location.href,
            };
            constantAPI.weChatShareConfig(shareInfo.link).then((result) => {
                wxShare.setWxConfig(result.data);
                wxShare.setShare(shareInfo);
            });
            pvuvAPI.addPv("baiTiaoShopping/store", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>
    .background {
        background-image: url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxzGjQ5.png');
        background-size: 100% 100%;
        height: 75rem;
        padding-top: 16rem;
        text-align: center;
    }

    .inputForm {
        background-color: white;
        width: 85%;
        margin: 0 auto;
        padding: 1rem;
    }

</style>
